const BROWSER_TITLES = {
    DEFAULT: 'Mineral Platform',
    AUDIT_TRAIL: {
        SECTION: 'Audit Trail',
        DETAILS: null,
    },
    AFFILIATES: {
        SECTION: 'Affiliates',
        EDIT: 'Edit Affiliate #${affiliateId}',
        LIST: null,
    },
    AUTH: {
        SECTION: null,
        ACCOUNT_PASSWORD_RESET: 'Reset Password',
        CONTACT_TECH_SUPPORT: 'Contact Tech Support',
        CONTACT_TECH_SUPPORT_SUCCESS: 'Success - Contact Tech Support',
        FORGOT_PASSWORD: 'Forgot Password',
        FORGOT_PASSWORD_SUCCESS: 'Password Reset Link Sent',
        FORGOT_USERNAME: 'Forgot Username',
        HELP_OPTIONS: 'Help Options',
        PASSWORD_LINK_EXPIRED: 'Password Link Expired',
        PASSWORD_HAS_BEEN_RESET: 'Password Has Been Reset',
        SET_YOUR_PASSWORD: 'Set Your Password',
        SIGN_IN: 'Sign-in',
    },
    BANNERS: {
        SECTION: 'Banners',
    },
    COMPANY_POLICIES: {
        SECTION: 'Company Policies',
        HANDBOOKS: 'Handbooks',
        HANDBOOKS_LIBRARY: 'Library',
        CUSTOM_POLICIES: 'Custom Policies',
        ARCHIVED_HANDBOOKS: 'Archived Handbooks',
        CREATE_NEW_HANDBOOK: {
            SECTION: 'New Handbook for Company #${companyId}',
            URL: '/company-policies/handbooks/create/${partnerId}/${companyId}',
        },
        DOCUMENT_SIGNATURES: 'Document Signatures',
        E_DOCUMENTS_SIGNATURES: 'E-Signature Management',
        CREATE_NEW_POLICY: 'New Custom Policy',
        E_SIGNATURES: {
            SECTION: 'E-Signature for #${signatureDocumentId} #${handbookId}',
            URL: '/company-policies/documents/${signatureDocumentId}/${handbookId}/details',
        },
        E_DOCUMENTS_REPORTING: 'E-Signature Reporting',
        E_DOCUMENTS_REPORTING_DESCRIPTION:
            "<p>View the signature status and due dates for one or more Smart Employee Handbooks sent for E-Signature.</p><p>You'll receive an email when the report is generated.</p>",
    },
    BRANDING: {
        SECTION: 'Branding',
        COLORS: 'Colors for Partner #${partnerId}',
        CONTACT_SETTINGS: 'Contact Settings for Partner #${partnerId}',
        LIST: null,
        LOGOS: 'Logos for Partner #${partnerId}',
        SIGN_IN_SIGN_OUT: 'Sign In/Out for Partner #${partnerId}',
        SIGN_IN_WIDGET: 'Sign-In Widget for Partner #${partnerId}',
    },
    CASE_CAVE: {
        SECTION: 'Case Cave',
        ASSIGNMENTS: 'Assignments',
        CASES: 'Cases',
        CASE_DETAILS: 'Case #${caseId}',
        CREATE_NEW_CASE: 'Create New Case',
        DASHBOARD: 'Dashboard',
        PREPPED_ANSWERS: 'Prepped Answers',
        PREPPED_ANSWERS_CLONE: 'Clone Prepped Answer #${id}',
        PREPPED_ANSWERS_DETAIL: 'Prepped Answer #${id}',
        PREPPED_ANSWERS_EDIT: 'Edit Prepped Answer #${id}',
        PREPPED_ANSWERS_NEW: 'Create Prepped Answer',
        MESSAGES: 'Messages',
        MEETINGS: 'Meetings',
        PA_UPDATES: 'Prepped Answer Updates',
        TRANSFER_CASES: 'Transfer Cases',
        UNKNOWN_CASES: 'Unknown Cases',
        USER_LOOKUP: 'User Lookup',
        VPA: 'Vetted Prepped Answers',
    },
    CLIENT_CASES: {
        SECTION: 'Client Cases',
        ASK_AN_EXPERT: 'Ask an Expert',
    },
    COMMUNICATION: {
        SECTION: 'Communication',
        CHOOSE_PARTNER: null,
        NOTIFICATIONS: 'Notifications for #${partnerId}',
        ONBOARDING_EMAILS: 'Onboarding Email for #${partnerId}',
        PAST_COMMUNICATIONS: 'Past Communications for #${partnerId}',
        UPCOMING_COMMUNICATIONS: 'Upcoming Communications for #${partnerId}',
        WELCOME_EMAIL_SETTINGS: 'Welcome Email for #${partnerId}',
    },
    CONFIGURATIONS: {
        SECTION: 'Configurations',
        AUDIT_TRAIL: 'Audit Trail',
        DETAILS: 'Configuration #${configurationId}',
        EDIT: 'Edit Configuration #${configurationId}',
        LIST: null,
    },
    DHE_AUDITS: {
        SECTION: 'Dedicated Expert Audits',
        SECTION_EXTERNAL: 'Guided HR Assessments',
        DETAILS: 'Audit #${surveyResponseId}',
        DETAILS_EXTERNAL: 'Assessment #${surveyResponseId}',
        DETAILS_NOT_FOUND: 'Audit Not Found',
        DETAILS_NOT_FOUND_EXTERNAL: 'Assessment Not Found',
        LIST: null,
    },
    HELP_CENTER: {
        SECTION: 'Help Center',
        CASES: 'Cases',
        COMPANY_POLICIES_AND_SMART_HANDBOOKS: 'Company Policies & Smart Handbooks',
        GETTING_STARTED: 'Getting Started',
        HR_COMPLIANCE: 'HR Compliance',
        LANDING_PAGE: null,
        LEARN: 'Learn',
        MY_DASHBOARD: 'My Dashboard',
        SAFETY: 'Safety',
        SEARCH: 'Search',
        SMART_HANDBOOKS: 'Smart Handbooks',
    },
    LINK_CHECKER: {
        SECTION: 'Broken Link Tool',
    },
    MY_CASES: {
        SECTION: 'My Cases',
        ASK_AN_EXPERT: 'Ask an Expert',
        CLIENT_CASES: 'Client Cases',
        CLIENT_CASE_DETAILS: 'Client Case #${id}',
        MY_CASES: null,
        MY_CASE_DETAILS: 'My Case #${id}',
        MY_MEETINGS: 'My Meetings',
        MY_MESSAGES: 'My Messages',
        TECHNICAL_SUPPORT: 'Technical Support',
    },
    MY_DASHBOARD: {
        SECTION: 'My Dashboard',
    },
    MY_PROFILE: {
        SECTION: 'My Profile',
        DETAILS: 'Details',
        EDIT: 'Edit',
    },
    MY_TODO_LIST: {
        SECTION: 'My To Do List',
    },
    MAP_PORTAL: {
        SECTION: 'MAP Portal',
    },
    PARTNER_ENABLEMENT: {
        SECTION: 'Partner Enablement',
    },
    PRODUCTS_AND_SERVICES: {
        SECTION: 'Products and Services',
        CREATE: 'Create',
        DETAILS: 'SKU #${skuId}',
        EDIT: 'Edit SKU #${skuId}',
        LIST: null,
    },
    PROSPECTS: {
        SECTION: 'Manage Prospects',
        ADD: 'Add New Prospect',
        BULK_IMPORT: 'Add Multiple Prospects',
        EDIT: 'Edit Prospect #${prospectId}',
        LIST: null,
    },
    PUBLIC: {
        PROSPECT: {
            SECTION: 'HR Assessment',
            ASSESSMENT_TOOL: null,
            ASSESSMENT_TOOL_INVALID: 'Invalid Link',
            ASSESSMENT_TOOL_SUCCESS: 'Results',
        },
    },
    REPORTING: {
        SECTION: 'Reporting',
        ADMINISTRATION_REPORTS: 'Administration Reports',
        ANONYMOUS_REPORTING: 'Anonymous Reporting',
        CLIENT_SOLUTION_REPORT: 'Client Solution Report',
        CLIENT_USAGE: 'Client Usage',
        CLIENT_VALUE_REPORT: 'Client Value Report',
        COMMUNICATIONS_REPORT: 'Communications Report',
        PARTNER_VALUE_REPORT: 'Partner Value Report',
    },
    ROLES: {
        SECTION: 'Roles',
        CREATE: 'Create',
        DETAILS: 'Role #${roleId}',
        EDIT: 'Edit Role #${roleId}',
        LIST: null,
    },
    AI_ASSISTANT: {
        SECTION: 'Ask ARIES',
    },
    ADMIN: {
        COMPANIES: {
            SECTION: 'Companies',
            EDIT: 'Edit Company #${companyId}',
            DETAILS: 'Company #${companyId}',
            BATCH_DEACTIVATION: 'Batch Deactivation',
            CHOOSE_PARTNER: 'New Company - Choose A Partner',
            CREATE: 'New Company for Partner #${partnerId}',
            IMPORT_CONTACTS: 'Import Users - Company #${companyId}',
            IMPORT_CLIENTS: 'Import Clients - Partner #${partnerId}',
            IMPORT_LOCATIONS: 'Import Locations - Company #${companyId}',
            IMPORT_HISTORY: 'Import History - Company #${companyId}',
            LICENSING_LIMIT: 'Licensing Limits - Partner #${partnerId}',
            ADD_NEW_LOCATION: 'Add New Location - Company #${companyId}',
            EDIT_LOCATION: 'Edit Location #${locationId} - Company #${companyId}',
            COMPANY_LOCATIONS: 'Company Locations - Company #${companyId}',
            SEND_WELCOME_EMAIL: 'Send Welcome Emails - Company #${companyId}',
            SSO_API_OPTIONS: 'SSO API Options - Partner #${companyId}',
            SSO_API_CONFIGURATION: 'SSO API Configuration - Partner #${companyId}',
            SSO_CONFIGURATION: 'SSO Configuration - Partner #${companyId}',
            SUPPORT_HR_CONTACT: 'Support/HR Contact - Partner #${partnerId}',
            WEBHOOK_SETTINGS_MINTEL: 'Webhook Settings Mintel - Partner #${partnerId}',
            CUSTOM_API: 'Custom API - Partner #${partnerId}',
            ADMINISTRATION_OPTIONS: 'Administration Options - Partner #${companyId}',
            LIST: null,
        },
    },
};

export default BROWSER_TITLES;
